import type { ReactNode } from "react";

export interface SectionProps {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  id?: string;
}

export function Section({ title, description, actions, children, id }: SectionProps): React.JSX.Element {
  const titleId = id ? `${id}-title` : undefined;
  return (
    <section className="nb-section" id={id} aria-labelledby={titleId}>
      <div className="nb-section-head">
        <div>
          <h2 id={titleId}>{title}</h2>
          {description ? <p>{description}</p> : null}
        </div>
        {actions}
      </div>
      {children}
    </section>
  );
}
